import { useMutation, useQuery } from 'react-apollo';

import { PURCHASED_DIGITAL_BUNDLE_STATUS } from '../../../../../../../../constants/digital-bundles';
import { MeWithPurchasedDigitalBundles } from '../../../../../../../../graphql/queries/account';
import { purchasedDigitalBundlePhotosCreate as purchasedDigitalBundlePhotosCreateMutation } from '../../../../../../../../graphql/mutations/digital-bundles';

const usePendingDigitalBundles = ({
  albumFolderId,
  albumId,
  identityId,
  pendingConfigurationOnly = false,
}) => {
  const { data: { me } = {}, loading } = useQuery(
    MeWithPurchasedDigitalBundles,
    {
      variables: {
        identity_id: pendingConfigurationOnly ? undefined : identityId,
        album_folder_id: albumFolderId,
        album_id: albumId,
        digital_bundle_status: PURCHASED_DIGITAL_BUNDLE_STATUS.PENDING,
        pending_configuration_only: pendingConfigurationOnly,
      },
      skip:
        (!identityId && !pendingConfigurationOnly) ||
        (!albumFolderId && !albumId),
    },
  );

  const [purchasedDigitalBundlePhotosCreate] = useMutation(
    purchasedDigitalBundlePhotosCreateMutation,
  );

  const onPurchasedDigitalBundlePhotosCreate = async ({
    purchasedDigitalBundleId,
    photoIds,
  }) => {
    const result = await purchasedDigitalBundlePhotosCreate({
      variables: {
        input: {
          purchased_digital_bundle_id: purchasedDigitalBundleId,
          photo_ids: photoIds,
        },
      },
    });

    return result;
  };

  return {
    loadingPurchasedDigitalBundles: loading,
    purchasedDigitalBundles: me?.purchased_digital_bundles?.records ?? [],
    onPurchasedDigitalBundlePhotosCreate,
  };
};

export default usePendingDigitalBundles;
